import { render } from "./MigrateImageStoreResource.vue?vue&type=template&id=c39681e2&scoped=true"
import script from "./MigrateImageStoreResource.vue?vue&type=script&lang=js"
export * from "./MigrateImageStoreResource.vue?vue&type=script&lang=js"

import "./MigrateImageStoreResource.vue?vue&type=style&index=0&id=c39681e2&scoped=true&lang=less"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c39681e2"]])

export default __exports__